// oxlint-disable-next-line no-restricted-imports
import { ConfigProvider } from "antd";
import germanLocale from "antd/es/locale/de_DE";
import englishLocale from "antd/es/locale/en_GB";
import dutchLocale from "antd/es/locale/nl_NL";

import { useTranslation } from "@/translations";

interface Props {
  children: React.ReactNode;
}

// We need to map between AntD (xx_YY) and date-fns locales (xx)
if (dutchLocale.DatePicker) {
  dutchLocale.DatePicker.lang.locale = "nl";
}

if (germanLocale.DatePicker) {
  germanLocale.DatePicker.lang.locale = "de";
}

export function DateTimePickerConfigProvider({ children }: Props): React.ReactNode {
  const { i18n } = useTranslation();
  const userLocale = getDateTimePickerLocale(i18n.language);

  return (
    <ConfigProvider
      locale={userLocale}
      theme={{
        token: {
          colorPrimary: "var(--color-text-brand)",
          colorPrimaryBorder: "var(--color-border-brand)",
          colorPrimaryBg: "var(--color-background-brand-light)",
          fontFamily: "var(--font-family-sans)",
          colorError: "var(--color-border-danger)",
          colorErrorText: "var(--color-text-danger)",
          colorErrorBorderHover: "var(--color-border-danger)",
          borderRadius: 8,
        },
        components: {
          DatePicker: {
            borderRadiusLG: 12,
            cellHoverBg: "var(--color-background-brand-light)",
            activeBorderColor: "var(--color-border-brand-secondary)",
            hoverBorderColor: "var(--color-border-brand-secondary)",
            activeShadow: "0px 0px 0px 4px var(--color-border-default)",
            errorActiveShadow: "0px 0px 0px 4px var(--color-border-danger-tertiary)",
            cellActiveWithRangeBg: "#DDECF6",
            colorTextDisabled: "var(--color-text-disabled)",
            colorBgContainerDisabled: "var(--color-background-secondary)",
            colorBorder: "var(--color-border-secondary)",
            colorTextPlaceholder: "var(--color-text-secondary)",
          },
        },
      }}
    >
      {children}
    </ConfigProvider>
  );
}

function getDateTimePickerLocale(lang?: string) {
  switch (lang) {
    case "nl":
    case "dutch":
      return dutchLocale;
    case "de":
    case "german":
      return germanLocale;
    default:
      return englishLocale;
  }
}
